import { useState } from 'react';
import Profile from './profile/Profile';
import Integrations from './integrations/Integrations';
import './Settings.css';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('profile');

  const tabs = [
    { id: 'profile', label: 'Profile' },
    { id: 'integrations', label: 'Integrations' }
  ];

  return (
    <div className='settings-container'>
      <nav className='settings-nav'>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`nav-item ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </nav>
      <div className='settings-content'>
        {activeTab === 'profile' && <Profile />}
        {activeTab === 'integrations' && <Integrations />}
      </div>
    </div>
  );
};

export default Settings;